import * as React from 'react';
import { NavLink } from "react-router-dom"
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';
import { activityPrefixManagementHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";


export const ListTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadMore, loadMoreContent, loadMoreTask, roleManagement, onView, onDelete } = props;
    const classes = customStyles();

    return (        
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            heads={activityPrefixManagementHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            loadMoreTask={() => loadMoreTask()}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={7}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell style={{ width: getColumnWidth(activityPrefixManagementHead, 0) }}><span style={{ width: getColumnWidth(activityPrefixManagementHead, 0) }}>{data?.feature?.module?.module}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(activityPrefixManagementHead, 1) }}><span style={{ width: getColumnWidth(activityPrefixManagementHead, 1) }}>{data?.feature?.featureName}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(activityPrefixManagementHead, 2) }}><span style={{ width: getColumnWidth(activityPrefixManagementHead, 2) }}>{data?.prefix}</span></TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Activity Prefix Management', 'edit', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data, false)}>
                                                            <Image src={EditIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Activity Prefix Management', 'view', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data, true)}>
                                                            <Image
                                                                src={ViewIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Activity Prefix Management', 'deletable', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={4}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>No results found</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}